import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
export function Partnerships() {
  const categories = [{
    label: 'Financial Institutions',
    desc: 'Banking, capital, and funding partners'
  }, {
    label: 'Workforce Development',
    desc: 'Talent pipelines and skills initiatives'
  }, {
    label: 'Innovation Ecosystems',
    desc: 'Accelerators, incubators, research hubs'
  }, {
    label: 'Telecom & Technology',
    desc: 'Digital infrastructure and platforms'
  }, {
    label: 'Economic Development',
    desc: 'Public sector and policy partners'
  }, {
    label: 'Leadership Initiatives',
    desc: 'Executive programs and institutions'
  }];
  return <section id="partnerships" className="py-24 lg:py-40 bg-warm-sand relative overflow-hidden" data-id="element-170">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-golden-yellow/40 to-transparent" data-id="element-171"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-172">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-173">
          <div className="lg:col-span-5" data-id="element-174">
            <FadeIn data-id="element-175">
              <p className="text-[11px] font-semibold tracking-[0.4em] uppercase text-vivid-orange mb-8" data-id="element-176">
                Partnerships
              </p>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-medium leading-[1.05] text-deep-azure mb-8" data-id="element-177">
                Building Strategic{' '}
                <em className="italic font-light text-dark-azure" data-id="element-178">Ecosystem</em>{' '}
                Partnerships.
              </h2>
              <p className="text-lg text-charcoal-navy/75 leading-relaxed mb-10 font-light" data-id="element-179">
                We collaborate with organizations, institutions, ecosystem
                leaders, and innovation partners committed to creating
                measurable advancement opportunities for women founders and
                leaders.
              </p>

              <a href="#cta" className="inline-flex items-center gap-2 text-vivid-orange hover:text-vivid-orange-light font-medium text-sm tracking-[0.05em] uppercase transition-colors group" data-id="element-180">
                Partner With Us
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-181" />
              </a>
            </FadeIn>
          </div>

          <div className="lg:col-span-7" data-id="element-182">
            <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-warm-sand-dark/30" data-id="element-183">
              {categories.map((category, index) => <StaggerItem key={index} className="bg-warm-sand p-8 hover:bg-soft-white transition-colors duration-500 group" data-id="element-184">
                  <div className="flex items-start justify-between mb-3" data-id="element-185">
                    <span className="text-[10px] font-display italic text-golden-yellow font-semibold" data-id="element-186">
                      0{index + 1}
                    </span>
                    <ArrowRight className="w-4 h-4 text-deep-azure/30 group-hover:text-vivid-orange group-hover:translate-x-1 transition-all" data-id="element-187" />
                  </div>
                  <h3 className="text-lg font-display font-medium text-deep-azure mb-2 tracking-tight" data-id="element-188">
                    {category.label}
                  </h3>
                  <p className="text-xs text-charcoal-navy/60 leading-relaxed font-light" data-id="element-189">
                    {category.desc}
                  </p>
                </StaggerItem>)}
            </StaggerContainer>

            {/* Editorial partner logo wall */}
            <FadeIn delay={0.4} className="mt-16" data-id="element-190">
              <p className="text-[10px] font-semibold tracking-[0.3em] uppercase text-deep-azure/50 mb-6" data-id="element-191">
                Ecosystem Partners
              </p>
              <div className="grid grid-cols-3 md:grid-cols-4 gap-px bg-warm-sand-dark/30" data-id="element-192">
                {[1, 2, 3, 4].map((_, i) => <div key={i} className="h-20 bg-warm-sand flex items-center justify-center" data-id="element-193">
                    <span className="text-[10px] uppercase tracking-[0.3em] text-deep-azure/30 font-medium" data-id="element-194">
                      Partner
                    </span>
                  </div>)}
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}